(function ($) {

	var carouselSettings = {
		loop: true,
		margin: 50,
		navText: ['<i class="fa-solid fa-chevron-left"><span aria-label="Previous"></span></i>', '<i class="fa-solid fa-chevron-right"><span aria-label="Next"></span></i>'],
		dots: false,
		autoplay: false,
		autoplayHoverPause: false,
		responsive: {
			// breakpoint from 480 up
			0: {
				items: 1,
				nav: false,
				dots: true,
			},
			580: {
				items: 2,
				nav: true,

			},

			800: {
				items: 3,
				nav: true,
			},

			1200: {
				items: 4,
				nav: true,
			},
		}
	};

	var initializeBlock = function ($block) {

		// Check if something is defined in javascript
		if (typeof $block === 'undefined') {
			$block = $('body');
		}
		// console.log('1');
		$block.find(".owl-carousel.evblocks-logos__logos").owlCarousel(carouselSettings);
	}

	if (window.acf) {
		console.log('loaded');
		window.acf.addAction("render_block_preview/type=evblocks-logos", initializeBlock);
	} else {
		$(document).ready(function () {
			initializeBlock();
		});
	}
})(jQuery);
